import axiosInstance from '../lib/axios';

export const approvalService = {
  getPending: (params: { page?: number; limit?: number } = {}) =>
    axiosInstance.get('/approvals/pending', { params }),

  decideDocument: (documentId: string | number, action: 'Approved' | 'Rejected', reason = '') =>
    axiosInstance.post(`/documents/${documentId}/approve`, { action, reason }),

  decideAccessRequest: (requestId: number, payload: { action: 'Approved' | 'Rejected'; reason?: string }) =>
    axiosInstance.post(`/access-requests/${requestId}/decide`, payload),
};

export default approvalService;
